module.exports = __webpack_public_path__ + "static/media/blog_img5.7793634c.jpg";